// extracted by mini-css-extract-plugin
module.exports = {"footer":"Support_footer__obOsR","small":"Support_small__vAilN","switchContainer":"Support_switchContainer__p2uJZ","labelText":"Support_labelText__BsI4B"};